<script>
  import solicitacaoTransferenciaServico from '../servico';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import formasPagamento from '~js/formas-pagamento-transferencia';

  export default {
    components: { Cabecalho },
    data() {
      return {
        solicitacao: {},
        carregando: true,
        configuracao: this.$storage.configuracao(),
        formasPagamento: formasPagamento,
      }
    },
    methods: {
      carregar: function(id) {
        this.carregando = true;

        solicitacaoTransferenciaServico
          .obterPorId(id)
          .then(solicitacao => {
            this.carregando = false;
            this.solicitacao = solicitacao;
          });
      },
      classeOpcoes(valor) {
        return valor ? 'fa-check-square-o' : 'fa-square-o';
      },
      formaPagamento(id) {
        return this.formasPagamento.find(f => {
          return f.id === id;
        });
      },
    },
    computed: {
      dataLiberacaoCoordenador() {
        return this.$options.filters.formatarNumeroEmDataExtenso(this.solicitacao.dataLiberacao) || '---';
      }
    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de Transferência - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';      

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'solicitacao-transferencia';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">

              <p v-show="carregando" class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>


              <div v-if="!carregando">
                <cabecalho titulo="Solicitação de Transferência"></cabecalho>

                <h3 class="m-t-none m-b">Dados da solicitação</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.idSolicitacaoTransferencia || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Data da solicitação</dt>
                    <dd>{{ solicitacao.dataSolicitacao | formatarNumeroEmData }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Data da transferência</dt>
                    <dd>{{ solicitacao.dataTransferencia | formatarNumeroEmData }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Número documento</dt>
                    <dd>{{ solicitacao.documento }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Data de liberação do coordenador</dt>
                    <dd>{{ dataLiberacaoCoordenador }}</dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Liberado por</dt>
                    <dd>{{ solicitacao.liberadoPor ? solicitacao.liberadoPor.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Forma de pagamento</dt>
                    <dd>{{ formaPagamento(solicitacao.formaPagamento).nome }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Valor (R$)</dt>
                    <dd>{{ solicitacao.valorTransferencia || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Complemento</dt>
                    <dd>{{ solicitacao.complementoTransferencia }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Observação</dt>
                    <dd>{{ solicitacao.observacao }}</dd>
                  </dl>
                </div>

                <h3 class="m-t-none m-b">Projetos débito</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row" v-if="solicitacao.idContaDebito">
                    <dl class="col-xs-12">
                        <dt>Conta</dt>
                        <dd>{{ this.solicitacao.contaDebito.nome }}</dd>
                    </dl>
                </div>

                <div class="row" v-for="(rateioDebito, index) in this.solicitacao.solTransRateioDebito">
                  <dl class="col-xs-4">
                    <dt>Projeto</dt>
                    <dd>{{rateioDebito.projeto.nomeProjeto}}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Meta\Etapa</dt>
                    <dd>{{ rateioDebito.projetoMetaEtapa ? rateioDebito.projetoMetaEtapa.meta.nome + ' - ' + rateioDebito.projetoMetaEtapa.etapa.nome : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Rubrica</dt>
                    <dd>{{rateioDebito.rubrica.nome}}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Subrubrica</dt>
                    <dd>{{rateioDebito.subrubrica.nome}}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Valor</dt>
                    <dd>{{rateioDebito.valorRateio }}</dd>
                  </dl>
                </div>

                <h3 class="m-t-none m-b">Projetos crédito</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row" v-if="solicitacao.idContaCredito">
                    <dl class="col-xs-12">
                        <dt>Conta</dt>
                        <dd>{{ this.solicitacao.contaCredito.nome }}</dd>
                    </dl>
                </div>

                <div class="row" v-for="(rateioCredito, index) in this.solicitacao.solTransRateioCredito">
                  <dl class="col-xs-4">
                    <dt>Projeto</dt>
                    <dd>{{rateioCredito.projeto.nomeProjeto}}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Meta\Etapa</dt>
                    <dd>{{ rateioCredito.projetoMetaEtapa ? rateioCredito.projetoMetaEtapa.meta.nome + ' - ' + rateioCredito.projetoMetaEtapa.etapa.nome : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Rubrica</dt>
                    <dd>{{rateioCredito.rubrica.nome}}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Subrubrica</dt>
                    <dd>{{rateioCredito.subrubrica.nome}}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Valor</dt>
                    <dd>{{rateioCredito.valorRateio }}</dd>
                  </dl>
                </div>

                <div class="hr-line-dashed margin-top-5" v-if="this.configuracao.solTransferenciaMsgConfirmacao"></div>

                <div class="row" v-if="this.configuracao.solTransferenciaMsgConfirmacao">
                  <div class="col-md-12">
                    <p><i>{{this.configuracao.solTransferenciaMsgConfirmacao}}</i></p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-transferencia/componentes/SolicitacaoTransferenciaRelatorio.vue